import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    image: "https://i.ibb.co/CpdN21nD/logomarca-mais-marcada.png",
    label: "NOVA COLEÇÃO",
    title: "Clássicos\nda Moda",
    subtitle: "CAPÍTULO I: ALFAIATARIA",
    cta: "VER COLEÇÃO",
    href: "/catalogo",
    align: "right",
  },
  {
    image: "https://i.ibb.co/DHFy5hPc/a9a27297-0fab-478e-8848-d2df1cdf9464.png",
    label: "DESTAQUES",
    title: "Elegância\nAtemporal",
    subtitle: "VESTIDOS & CONJUNTOS",
    cta: "EXPLORAR",
    href: "/catalogo",
    align: "left",
  },
  {
    image: "https://i.ibb.co/WJ6FcNr/Gemini-Generated-Image-yae3xmyae3xmyae3.jpg",
    label: "PRÉ-VENDA",
    title: "Verão\n2026",
    subtitle: "PEÇAS EXCLUSIVAS",
    cta: "COMPRAR AGORA",
    href: "/catalogo",
    align: "right",
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  const goTo = useCallback(
    (index: number) => {
      if (animating) return;
      setAnimating(true);
      setCurrent(index);
      setTimeout(() => setAnimating(false), 600);
    },
    [animating]
  );

  const prev = () => goTo((current - 1 + slides.length) % slides.length);
  const next = () => goTo((current + 1) % slides.length);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const slide = slides[current];

  return (
    <section className="relative w-full overflow-hidden bg-black" style={{ height: "clamp(380px, 60vw, 700px)" }}>
      {/* Slides */}
      {slides.map((s, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={s.image}
            alt={s.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/20 to-black/40" />
        </div>
      ))}

      {/* Content */}
      <div
        className={`absolute inset-0 flex items-center ${
          slide.align === "right" ? "justify-end pr-10 md:pr-24 lg:pr-36" : "justify-start pl-10 md:pl-24 lg:pl-36"
        }`}
      >
        <div className="text-white text-center max-w-sm">
          <span className="inline-block text-[10px] tracking-[0.3em] font-medium mb-4 opacity-80 uppercase">
            {slide.label}
          </span>
          <h2
            className="text-4xl md:text-6xl font-light leading-[1.05] mb-4 whitespace-pre-line"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {slide.title}
          </h2>
          <p className="text-[11px] tracking-[0.25em] mb-8 opacity-70 uppercase">
            {slide.subtitle}
          </p>
          <Link
            to={slide.href}
            className="inline-block border border-white/70 px-8 py-3 text-[11px] tracking-[0.25em] uppercase hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap"
          >
            {slide.cta}
          </Link>
        </div>
      </div>

      {/* Arrows */}
      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center text-white/70 hover:text-white transition-colors cursor-pointer"
        aria-label="Anterior"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center text-white/70 hover:text-white transition-colors cursor-pointer"
        aria-label="Próximo"
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>

      {/* Dots */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`transition-all duration-300 cursor-pointer ${
              i === current
                ? "w-6 h-1.5 bg-white rounded-full"
                : "w-1.5 h-1.5 bg-white/50 rounded-full hover:bg-white/80"
            }`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
